import { Injectable } from "@angular/core";
import { Observable, of as observableOf } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { AddonPaymentModelService } from "../services/addonPayment/addonPayment-model.service";
import { PaymentDetailModel } from "../../shared/entities/paymentDetail.model";
import { PurchasedPackModel } from "../../shared/entities/purchased-pack.model";

@Injectable()
export class AddonPaymentModelRepository {
	constructor(private service: AddonPaymentModelService) {}

	public createNewPaymentDetails(data?: PaymentDetailModel, mode?: "buy" | "trial" | "transfer" | "change"): Observable<PaymentDetailModel | null> {
		let result: Observable<PaymentDetailModel | PurchasedPackModel>;
		switch (mode) {
			case "buy":
				result = this.service.postPaymentDetailModel(data);
				break;
			case "change":
				result = this.service.postPaymentDetailModelChange(data);
				break;
			case "trial":
				result = this.service.postPaymentDetailModelTrial(data);
				break;
			case "transfer":
				result = this.service.postPaymentDetailModelTransfer(data);
				break;
			default:
				result = this.service.postPaymentDetailModel(data);
				break;
		}
		return result.pipe(
			map((response: any) => {
				let returnDataModel: any;

				if (response.code == 202) {
					return response;
				}

				if (mode === "trial" || mode === "transfer") {
					returnDataModel = new PurchasedPackModel().deserialize(response.object);
				} else {
					returnDataModel = new PaymentDetailModel().deserialize(response.object);
				}

				return returnDataModel;
			}),
			catchError((err) => {
				console.error(JSON.stringify(err));
				return observableOf(null);
			}),
		);
	}
}
